import _ from 'underscore';
import api from 'app/common/api';

const BATCHED_METRICS_THROTTLE = 30000; // 30 seconds

const METRIC_TYPES = {
    COUNTER: 'COUNTER',
    GAUGE: 'GAUGE',
    TIMER: 'TIMER'
};

const METRIC_NAMES = {
    CLIENT_ERROR: 'clientError',
    SEARCH: 'search'
};

let batchedMetricsList = [];

const _sendMetrics = () => {
    const metricsToSend = [...batchedMetricsList];
    batchedMetricsList = [];

    api.sendMetrics(metricsToSend).fail(() => {
        // Include failed metrics in any future attempt
        batchedMetricsList = [...batchedMetricsList, ...metricsToSend];
    });
};

const _sendMetricsThrottled = _.throttle(_sendMetrics, BATCHED_METRICS_THROTTLE);

const sendMetricsEvent = (name, type, value, tags = {}) => {
    // Remove tags that have null or undefined values
    const cleanedTags = Object.fromEntries(
        Object.entries(tags).filter((kvPair) => kvPair[1] !== null && kvPair[1] !== undefined)
    );

    batchedMetricsList = [...batchedMetricsList, { name, type, value, tags: cleanedTags }];
    _sendMetricsThrottled();
};

const createMetricsEventTimer = (name, tags = {}) => {
    const then = performance.now();

    return (additionalTags = {}) => {
        const now = performance.now();
        sendMetricsEvent(name, METRIC_TYPES.TIMER, now - then, { ...tags, ...additionalTags });
    };
};

export { METRIC_TYPES, METRIC_NAMES, sendMetricsEvent, createMetricsEventTimer };
